import CommonAPI from './CommonAPI.js';
import Auth from './Auth.js'

import Logger from './Logger.js'
import CommonUtil from './CommonUtil.js'


export default {

  requestCode(userKey, phone, hash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      '/api/auth-code/send',
      {
        userKey: userKey,
        phone: phone,
        hash: hash
      },
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
},

confirmCode(userKey, phone, hash, codeToken, code, func_ok, func_error) {
  if (!func_error) func_error = this._common_error

  return CommonAPI.instance().post(
    '/api/auth-code/confirm',
    {
      userKey: userKey,
      phone: phone,
      hash: hash,
      codeToken: codeToken,
      code: code,
    },
    {})
    .then(res => func_ok(res.data))
    .catch((err) => func_error(err))
},

checkAuth(func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
        '/api/auth/check',
        {
        },
        {
            params: {
            },
            headers: Auth.headers()
        })
        .then(res => func_ok(res.data))
        .catch((err) => func_error(err))
},

intro(pageHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/answer/pages/${pageHash}/intro`,
      {
        params: {
        },
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  questions(pageHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/answer/pages/${pageHash}/form`,
      {
        params: {
        },
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  
  upload(hash, questionId, file, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    const formData = new FormData()
    formData.append('questionId', questionId)
    formData.append('file1', file)
    //formData.append('fileCount',1)

    let headers = Auth.headers()
    headers['Content-Type'] = 'multipart/form-data'

    return CommonAPI.instance().post(
      `/api/answer/${hash}/form/upload`,
      formData,
      {
        headers: headers,
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  submit(hash, answers, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      `/api/answer/pages/${hash}/submit`,
      {
        answers: answers
      },
      {
        headers: Auth.headers(),
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  owner(hash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/answer-owner/${hash}/answers`,
      {
        params: {
        },
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },


  _common_error(err) {
    Logger.debug("error" + err)
    alert(CommonUtil.extractErrorMessage(err))
  },
      
}